var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNoConnection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4044_100511)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4044_100511)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9988 4.75C13.7568 4.75 13.5171 4.76007 13.2802 4.77981C11.8319 7.14489 10.9459 9.83923 10.7063 12.6414H17.2903C17.0507 9.83919 16.1647 7.14483 14.7164 4.77973C14.4798 4.76004 14.2405 4.75 13.9988 4.75ZM18.5087 12.6414H22.4973C22.2394 9.00322 19.6867 5.99846 16.2758 5.05697C17.5296 7.38504 18.2946 9.9694 18.5087 12.6414ZM5.50021 12.6414C5.75813 9.0036 8.31033 5.99909 11.7207 5.05727C10.4669 7.38526 9.70201 9.96951 9.48793 12.6414H5.50021ZM5.5 13.8556H9.48779C9.70171 16.5287 10.4669 19.1141 11.7214 21.4429C8.30977 20.5011 5.75678 17.495 5.5 13.8556ZM13.2809 21.7203C11.8319 19.3544 10.9456 16.659 10.7061 13.8556H14V21.75H13.9988C13.757 21.75 13.5176 21.74 13.2809 21.7203ZM15.8935 14.6621C16.1864 14.3692 16.6613 14.3692 16.9542 14.6621L19.3457 17.0536L21.7372 14.6621C22.0301 14.3692 22.505 14.3692 22.7979 14.6621C23.0908 14.9549 23.0908 15.4298 22.7979 15.7227L20.4064 18.1143L22.7824 20.4903C23.0753 20.7832 23.0753 21.258 22.7824 21.5509C22.4895 21.8438 22.0146 21.8438 21.7217 21.5509L19.3457 19.1749L16.9697 21.5509C16.6768 21.8438 16.2019 21.8438 15.909 21.5509C15.6161 21.258 15.6161 20.7832 15.909 20.4903L18.285 18.1143L15.8935 15.7227C15.6006 15.4298 15.6006 14.9549 15.8935 14.6621Z",
    fill: "url(#paint0_linear_4044_100511)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4044_100511",
    x: 4.5,
    y: 4.75,
    width: 19.5176,
    height: 19.0205,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4044_100511"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4044_100511",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4044_100511",
    x: 4.5,
    y: 4.75,
    width: 19.5176,
    height: 19.0205,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4044_100511"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4044_100511",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4044_100511",
    x1: 14.2588,
    y1: 4.75,
    x2: 14.2588,
    y2: 21.7706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D0D0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNoConnection);
export default __webpack_public_path__ + "static/media/ic-no-connection.1d6ae07147feaa1e1805b57b4880a913.svg";
export { ForwardRef as ReactComponent };